import { apiClient, unwrap } from './client';

import type { ApiResponse, AssistantConversation, AssistantMessage } from '@/types';

export interface AssistantChatResult {
  user_message: AssistantMessage;
  assistant_message: AssistantMessage;
  conversation_id: number;
  mock: boolean;
}

/** 发送一条消息给 AI 助手（教师端/学生端人格由后端按当前用户角色自动区分） */
export async function sendAssistantMessage(
  message: string,
  conversationId?: number,
): Promise<AssistantChatResult> {
  const response = await apiClient.post<ApiResponse<AssistantChatResult>>(
    '/assistant/chat',
    { message, conversation_id: conversationId },
  );
  return unwrap(response);
}

/** 获取当前用户的所有会话 */
export async function getAssistantConversations(): Promise<AssistantConversation[]> {
  const response = await apiClient.get<ApiResponse<AssistantConversation[]>>(
    '/assistant/conversations',
  );
  return unwrap(response);
}

/** 新建会话 */
export async function createAssistantConversation(title?: string): Promise<AssistantConversation> {
  const response = await apiClient.post<ApiResponse<AssistantConversation>>(
    '/assistant/conversations',
    { title },
  );
  return unwrap(response);
}

/** 重命名会话 */
export async function renameAssistantConversation(
  id: number,
  title: string,
): Promise<AssistantConversation> {
  const response = await apiClient.put<ApiResponse<AssistantConversation>>(
    `/assistant/conversations/${id}`,
    { title },
  );
  return unwrap(response);
}

/** 删除会话 */
export async function deleteAssistantConversation(id: number): Promise<{ ok: boolean; deleted_conversation_id: number }> {
  const response = await apiClient.delete<ApiResponse<{ ok: boolean; deleted_conversation_id: number }>>(
    `/assistant/conversations/${id}`,
  );
  return unwrap(response);
}

/** 获取指定会话的聊天记录 */
export async function getAssistantHistory(conversationId: number): Promise<AssistantMessage[]> {
  const response = await apiClient.get<ApiResponse<AssistantMessage[]>>(
    `/assistant/history?conversation_id=${conversationId}`,
  );
  return unwrap(response);
}

/** 清空指定会话的聊天记录 */
export async function clearAssistantHistory(conversationId: number): Promise<{ ok: boolean; cleared: number }> {
  const response = await apiClient.delete<ApiResponse<{ ok: boolean; cleared: number }>>(
    `/assistant/history?conversation_id=${conversationId}`,
  );
  return unwrap(response);
}

